import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { computed, onMounted, watch } from 'vue';
import { useAuthStore, useTenantStore } from '@/store';
import { useIdle } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { idle } = useIdle(Number(process.env.VUE_APP_TIMEOUT));
const authStore = useAuthStore();
const tenantStore = useTenantStore();

/**
 * on mounted (refreshed) go get any access tokens in storage
 */
onMounted(() => init());

const init = async () => {
  await authStore.fetchAccessToken();
  await authStore.boot();
  document.body.classList.add('theme');
};

const isLoading = computed(() => authStore.loading);

/**
 * if idle for longer than 20 minutes then log them out
 */
const handleIdleValue = async (val: boolean) => {
  /**
   * if existing tenant is a guest tenant then leave it
   * if impersonating in that tenant be sure to leave that first
   */
  if (authStore.isImpersonating) {
    await authStore.leaveImpersonate(true);
  }
  if (authStore.isSwitchTenant) {
    const { guest_tenant } = authStore.impersonateTenantToken;
    await tenantStore.leaveTenant(guest_tenant.id);
    authStore.impersonateTenantToken = null;
  }
  if (val) authStore.stopLogin();
};

watch(idle, handleIdleValue);

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("head", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      (!isLoading.value)
        ? (_openBlock(), _createBlock(_component_BaseLayout, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_Toast, { position: "top-right" }),
              _createVNode(_component_RouterView)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})